import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { SemaforoSEInterface } from "../../../../../interfaces/SemaforoSEInterface";
import { ConclusionLlenadaSEInterface } from "../../../../../interfaces/ConclusionLlenadaSEInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import SkyClear from "../../../../../img/SkyClear.png";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ConclusionesSECrearScreen = () => {
  const tituloFormulario =
    "CONCLUSIONES DE EVALUACIÓN DE INVESTIGACIÓN SOCIOECONÓMICA Y/O PATRIMONIAL";
  const { control, reset, handleSubmit, getValues } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryConclusionSE = useGetData<ConclusionLlenadaSEInterface>({
    url: `/conclusionllenada_se/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_se"],
  });

  const mutateFechaSE = useMutationData({
    url: `/fecha-socioeconomica/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-socioeconomica"],
  });

  const mutateConclusionSE = useMutationData({
    url: `/conclusionllenada_se/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_se"],
  });

  const mutateResultadoSE = useMutationData({
    url: `/resultado-conclusionse/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "resultado-conclusionse"],
  });

  const querySemaforoSE = useGetData<SemaforoSEInterface>({
    url: `/semaforose/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforose"],
  });

  const mutateSemaforoSE = useMutationData({
    url: `/semaforose/${evaluadosList_id}`,
    reload: ["evaluado", "semaforose", `${evaluadosList_id}`],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        lugar_nacimiento: queryEvaluado.data.lugar_nacimiento || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryConclusionSE.data) {
      console.log("Datos cargados:", queryConclusionSE.data);
      reset({
        derivado_se: queryConclusionSE.data.derivado_se || "",
        regimen_se: queryConclusionSE.data.regimen_se || "",
        anioscasado_se: queryConclusionSE.data.anioscasado_se || "",
        numhijos_se: queryConclusionSE.data.numhijos_se || "",
        edadhijos_se: queryConclusionSE.data.edadhijos_se || "",
        numdependientes_se: queryConclusionSE.data.numdependientes_se || "",
        quienesdependen_se: queryConclusionSE.data.quienesdependen_se || "",
        aniostrabajando_se: queryConclusionSE.data.aniostrabajando_se || "",
        areapertenece_se: queryConclusionSE.data.areapertenece_se || "",
        fechalaborando_se: queryConclusionSE.data.fechalaborando_se || "",
        enterovacante_se: queryConclusionSE.data.enterovacante_se || "",
        recomendo_se: queryConclusionSE.data.recomendo_se || "",
        gastoalimentacion_se: queryConclusionSE.data.gastoalimentacion_se || "",
        gastovestido_se: queryConclusionSE.data.gastovestido_se || "",
        gastogasolina_se: queryConclusionSE.data.gastogasolina_se || "",
        gastotransporte_se: queryConclusionSE.data.gastotransporte_se || "",
        gastotelefono_se: queryConclusionSE.data.gastotelefono_se || "",
        gastodiversiones_se: queryConclusionSE.data.gastodiversiones_se || "",
        gastoautofinanciamiento_se:
          queryConclusionSE.data.gastoautofinanciamiento_se || "",
        gastootros1_se: queryConclusionSE.data.gastootros1_se || "",
        gastohipoteca_se: queryConclusionSE.data.gastohipoteca_se || "",
        gastorenta_se: queryConclusionSE.data.gastorenta_se || "",
        gastocolegiaturas_se: queryConclusionSE.data.gastocolegiaturas_se || "",
        gastoservicios_se: queryConclusionSE.data.gastoservicios_se || "",
        gastodeudas_se: queryConclusionSE.data.gastodeudas_se || "",
        gastoinversiones_se: queryConclusionSE.data.gastoinversiones_se || "",
        gastopension_se: queryConclusionSE.data.gastopension_se || "",
        gastootros2_se: queryConclusionSE.data.gastootros2_se || "",
        gastototal_se: queryConclusionSE.data.gastototal_se || "",
        ingresomensual_se: queryConclusionSE.data.ingresomensual_se || "",
        compuestopor_se: queryConclusionSE.data.compuestopor_se || "",
        ingresoesposa_se: queryConclusionSE.data.ingresoesposa_se || "",
        ingresosextra_se: queryConclusionSE.data.ingresosextra_se || "",
        ascienden_se: queryConclusionSE.data.ascienden_se || "",
        egresosfam_se: queryConclusionSE.data.egresosfam_se || "",
        compuestosde_se: queryConclusionSE.data.compuestosde_se || "",
        esposaegreso_se: queryConclusionSE.data.esposaegreso_se || "",
        deudasascienden1_se: queryConclusionSE.data.deudasascienden1_se || "",
        gastosaprox_se: queryConclusionSE.data.gastosaprox_se || "",
        deudasascienden2_se: queryConclusionSE.data.deudasascienden2_se || "",
        cuantosvehiculos_se: queryConclusionSE.data.cuantosvehiculos_se || "",
        marcavechiculo_se: queryConclusionSE.data.marcavechiculo_se || "",
        aniovehiculo_se: queryConclusionSE.data.aniovehiculo_se || "",
        adquiriovehiculo_se: queryConclusionSE.data.adquiriovehiculo_se || "",
        domicilioactual_se: queryConclusionSE.data.domicilioactual_se || "",
        tiempoviviendo_se: queryConclusionSE.data.tiempoviviendo_se || "",
        referenciavecinal1_se:
          queryConclusionSE.data.referenciavecinal1_se || "",
        referenciavecinal2_se:
          queryConclusionSE.data.referenciavecinal2_se || "",
        titularcuentabanco_se:
          queryConclusionSE.data.titularcuentabanco_se || "",
        tiempolibre_se: queryConclusionSE.data.tiempolibre_se || "",
        fuma_se: queryConclusionSE.data.fuma_se || "",
        cuantofuma_se: queryConclusionSE.data.cuantofuma_se || "",
        toma_se: queryConclusionSE.data.toma_se || "",
        cuantotoma_se: queryConclusionSE.data.cuantotoma_se || "",
        ultimavez_se: queryConclusionSE.data.ultimavez_se || "",
        consumedrogas_se: queryConclusionSE.data.consumedrogas_se || "",
        aniolaboral_se: queryConclusionSE.data.aniolaboral_se || "",
        externo1_se: queryConclusionSE.data.externo1_se || "",
        tiempolaborando1_se: queryConclusionSE.data.tiempolaborando1_se || "",
        tiempolaborando2_se: queryConclusionSE.data.tiempolaborando2_se || "",
        supervision_se: queryConclusionSE.data.supervision_se || "",
        telcoordinadora_se: queryConclusionSE.data.telcoordinadora_se || "",
        telsinexito_se: queryConclusionSE.data.telsinexito_se || "",
        externo2_se: queryConclusionSE.data.externo2_se || "",
        observaciones_se: queryConclusionSE.data.observaciones_se || "",
        drogasdescripcion_se: queryConclusionSE.data.drogasdescripcion_se || "",
        cuentaconfamiliares_se:
          queryConclusionSE.data.cuentaconfamiliares_se || "",
        comollego_se: queryConclusionSE.data.comollego_se || "",
        cuentasbancarias_se: queryConclusionSE.data.cuentasbancarias_se || "",
        cuantosinmuebles_se: queryConclusionSE.data.cuantosinmuebles_se || "",
        titulospropiedad_se: queryConclusionSE.data.titulospropiedad_se || "",
        comoadquirio1_se: queryConclusionSE.data.comoadquirio1_se || "",
        descripcionvehiculos: queryConclusionSE.data.descripcionvehiculos || "",
        titulosvehiculos_se: queryConclusionSE.data.titulosvehiculos_se || "",
        comoadquirio2_se: queryConclusionSE.data.comoadquirio2_se || "",
        procesospenales_se: queryConclusionSE.data.procesospenales_se || "",
        descripcionpenales_se:
          queryConclusionSE.data.descripcionpenales_se || "",
        anotedirecciones_se: queryConclusionSE.data.anotedirecciones_se || "",
        practicadeporte_se: queryConclusionSE.data.practicadeporte_se || "",
        cualdeporte_se: queryConclusionSE.data.cualdeporte_se || "",
        religionpertenece_se: queryConclusionSE.data.religionpertenece_se || "",
        estadosalud_se: queryConclusionSE.data.estadosalud_se || "",
        inmuebleperteece_se: queryConclusionSE.data.inmuebleperteece_se || "",
        relacionvecinos_se: queryConclusionSE.data.relacionvecinos_se || "",
        inpuestodemanda_se: queryConclusionSE.data.inpuestodemanda_se || "",
        motivodemanda_se: queryConclusionSE.data.motivodemanda_se || "",
        aniodemanda_se: queryConclusionSE.data.aniodemanda_se || "",
        tienecredito_se: queryConclusionSE.data.tienecredito_se || "",
        tipocredito_se: queryConclusionSE.data.tipocredito_se || "",
        autopaga_se: queryConclusionSE.data.autopaga_se || "",
        pagomensuales_se: queryConclusionSE.data.pagomensuales_se || "",
        tarjetaspaga_se: queryConclusionSE.data.tarjetaspaga_se || "",
        pagomensualtarjetas_se:
          queryConclusionSE.data.pagomensualtarjetas_se || "",
        tieneadeudoscredito_se:
          queryConclusionSE.data.tieneadeudoscredito_se || "",
        institucioncredito_se:
          queryConclusionSE.data.institucioncredito_se || "",
        cuantopagacredito_se: queryConclusionSE.data.cuantopagacredito_se || "",
        tienecreditofonacot_se:
          queryConclusionSE.data.tienecreditofonacot_se || "",
        cuantopagafonacot_se: queryConclusionSE.data.cuantopagafonacot_se || "",
        retrasocredito_se: queryConclusionSE.data.retrasocredito_se || "",
        burocredito_se: queryConclusionSE.data.burocredito_se || "",
        motivoburo_se: queryConclusionSE.data.motivoburo_se || "",
        ingresomensual2_se: queryConclusionSE.data.ingresomensual2_se || "",
        nombreprimaria_se: queryConclusionSE.data.nombreprimaria_se || "",
        ciudadprimaria_se: queryConclusionSE.data.ciudadprimaria_se || "",
        aniosprimaria_se: queryConclusionSE.data.aniosprimaria_se || "",
        periodoprimaria_se: queryConclusionSE.data.periodoprimaria_se || "",
        certificadoprimaria_se:
          queryConclusionSE.data.certificadoprimaria_se || "",
        nombresecundaria_se: queryConclusionSE.data.nombresecundaria_se || "",
        ciudadsecundaria_se: queryConclusionSE.data.ciudadsecundaria_se || "",
        aniossecundaria_se: queryConclusionSE.data.aniossecundaria_se || "",
        periodosecundaria_se: queryConclusionSE.data.periodosecundaria_se || "",
        certificadosecundaria_se:
          queryConclusionSE.data.certificadosecundaria_se || "",
        nombrebachillerato_se:
          queryConclusionSE.data.nombrebachillerato_se || "",
        ciudadbachillerato_se:
          queryConclusionSE.data.ciudadbachillerato_se || "",
        aniosbachillerato_se: queryConclusionSE.data.aniosbachillerato_se || "",
        periodobachillerato_se:
          queryConclusionSE.data.periodobachillerato_se || "",
        certificadobachillerato_se:
          queryConclusionSE.data.certificadobachillerato_se || "",
        nombrelicenciatura_se:
          queryConclusionSE.data.nombrelicenciatura_se || "",
        ciudadlicenciatura_se:
          queryConclusionSE.data.ciudadlicenciatura_se || "",
        anioslicenciatura_se: queryConclusionSE.data.anioslicenciatura_se || "",
        periodolicenciatura_se:
          queryConclusionSE.data.periodolicenciatura_se || "",
        certificadolicenciatura_se:
          queryConclusionSE.data.certificadolicenciatura_se || "",
        estudiaactualmente_se:
          queryConclusionSE.data.estudiaactualmente_se || "",
        dondeestudia_se: queryConclusionSE.data.dondeestudia_se || "",
        horarioestudio_se: queryConclusionSE.data.horarioestudio_se || "",
        indicarespecialidad_se:
          queryConclusionSE.data.indicarespecialidad_se || "",
        notaestudio_se: queryConclusionSE.data.notaestudio_se || "",
      });
    }
  }, [queryConclusionSE.data, reset]);

  useEffect(() => {
    if (querySemaforoSE.data) {
      const color = querySemaforoSE.data.color_se || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_se: color,
        evaluado_uuid: querySemaforoSE.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoSE.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className="space-y-4 p-4">
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_conclusionse" className="mr-2">
            FECHA EVALUACIÓN:
          </Label>
          <Controller
            name="fecha_conclusionse"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_conclusionse"
                type="date"
                {...field}
                className="text-center w-full"
              />
            )}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre">NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
          />
        </div>

        {/* FOTO */}
        <div className="w-64 h-64 border border-gray-300 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center mt-4 relative z-10">
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-gray-500">Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className="flex items-center gap-2 mt-4 mb-4">
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                onChange={handleRadioChange}
              />
              RECOMENDABLE
            </label>
            <label className="flex items-center gap-2 mt-12 mb-12">
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                onChange={handleRadioChange}
              />
              CON RESERVA
            </label>
            <label className="flex items-center gap-2 mb-12">
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                onChange={handleRadioChange}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc">RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad">EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo">SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className="mr-2">
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className="w-32"
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp">CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa">EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className="space-y-6 p-6 bg-gray-50 rounded-lg shadow-md">
      <div className="bg-customBlue text-white p-4 rounded-lg shadow">
        <h2 className="font-bold text-xl">
          CONCLUSIONES DE EVALUACIONES DE INVESTIGACIÓN SOCIOECONÓMICA Y/O
          PATRIMONIAL
        </h2>
      </div>

      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">DATOS RELEVANTES</p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Derivado de la valoración y revisión de la información, se considera
          que es una{" "}
          <strong>
            PERSONA{" "}
            <Controller
              name="marcavechiculo_se"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <input
                  {...field}
                  id="marcavechiculo_se"
                  type="text"
                  className="border border-gray-300 rounded-md p-2 w-[400px] inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                  placeholder="¿Como es?"
                />
              )}
            />{" "}
          </strong>
          , en virtud de que al momento de la evaluación de la investigación
          socioeconómica se detectó:{" "}
          <Controller
            name="adquiriovehiculo_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                {...field}
                id="adquiriovehiculo_se"
                className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                aria-label="adquiriovehiculo_se"
                placeholder="Escribe lo que detectarón aquí..."
              />
            )}
          />
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Se procedió a la revisión minuciosa de todos y cada uno de los
          documentos que el candidato exhibió, mediante lo cual se considera lo
          siguiente:
        </p>
      </div>

      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">ESTADO DE SALUD</p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Considera su estado de salud{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.estadosalud_se}`}
          </label>
          , derivado que{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.derivado_se}`}
          </label>
          .
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">VIDA FAMILIA</p>

        <p className="text-justify text-gray-800 leading-relaxed">
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          refiere ser{" "}
          <label
            htmlFor="estado_civil"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.estado_civil || ""}`}
          </label>
          , por el régimen de{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.regimen_se}`}
          </label>{" "}
          cuenta con{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.anioscasado_se}`}
          </label>{" "}
          años de{" "}
          <label
            htmlFor="estado_civil"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.estado_civil || ""}`}
          </label>
          , tiene{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.cuantos_hijos || 0}`}
          </label>{" "}
          {Number(queryEvaluado.data?.cuantos_hijos) === 1 ? "hijo" : "hijos"}
          {Number(queryEvaluado.data?.cuantos_hijos) > 0 && (
            <>
              {" "}
              de{" "}
              <label
                htmlFor="nombre"
                className="text-gray-800 font-medium inline-block"
              >
                {[
                  queryEvaluado.data?.edad_hijo1,
                  queryEvaluado.data?.edad_hijo2,
                  queryEvaluado.data?.edad_hijo3,
                  queryEvaluado.data?.edad_hijo4,
                ]
                  .filter((edad) => edad !== null && edad !== undefined)
                  .join(", ")}
              </label>{" "}
              años de edad,
            </>
          )}{" "}
          tiene{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.numdependientes_se}`}
          </label>{" "}
          dependientes económicos, siendo estos{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.quienesdependen_se}`}
          </label>
          .
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">AMBITO LABORAL</p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Manifiesta que labora en la empresa{" "}
          <label
            htmlFor="empresa"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.empresa_id?.nombre || ""}`}
          </label>{" "}
          desde hace{" "}
          <label
            htmlFor="empresa"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.antiguedad || ""}`}
          </label>{" "}
          y pertenece al área de{" "}
          <label
            htmlFor="empresa"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.puesto || ""}`}
          </label>
          , ingresó a laborar el{" "}
          <label
            htmlFor="empresa"
            className="text-gray-800 font-medium inline-block"
          >
            {queryEvaluado.data?.fecha_ingreso
              ? new Date(queryEvaluado.data.fecha_ingreso).toLocaleDateString(
                  "es-ES"
                )
              : ""}
          </label>
          , refiere que no cuenta con familiares laborando en la empresa, en el
          momento que ingresó.
        </p>
        <p className="text-justify text-gray-800 leading-relaxed">
          Se enteró de la vacante por{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.enterovacante_se}`}
          </label>{" "}
          , y lo recomendó{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.recomendo_se}`}
          </label>{" "}
          .
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">
          DISTRIBUCION DE GASTOS
        </p>

        {/* Tabla de distribución mensual de gastos */}
        <div className="w-full overflow-x-auto">
          <table className="table-auto border-collapse border border-gray-300 w-full">
            {/* Header */}
            <thead>
              <tr>
                <th
                  className="border border-gray-300 px-4 py-2 bg-gray-100 text-center text-gray-700 font-semibold"
                  colSpan={2}
                >
                  DISTRIBUCION MENSUAL DE GASTOS
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Filas */}
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Alimentación
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastoalimentacion_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Vestido y Calzado
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastovestido_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Gasolina
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastogasolina_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Transporte
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastotransporte_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Teléfono
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastotelefono_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Diversiones
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastodiversiones_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Autofinanciamiento
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastoautofinanciamiento_se"
                    value={`$ ${queryConclusionSE.data?.gastoautofinanciamiento_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Otros
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastootros1_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <br />
          </div>
          <table className="table-auto border-collapse border border-gray-300 w-full">
            <tbody>
              {/* Filas */}
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Hipoteca
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastohipoteca_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Renta
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastorenta_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Colegiaturas
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastocolegiaturas_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Servicios
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastoservicios_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Deudas
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastodeudas_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Inversiones
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryConclusionSE.data?.gastoinversiones_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Pensión Alimenticia
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastopension_se"
                    value={`$ ${queryConclusionSE.data?.gastopension_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Otros
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastootros2_se"
                    value={`$ ${queryConclusionSE.data?.gastootros2_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Total
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastototal_se"
                    disabled={true}
                    type="text"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$0.00"
                    value={`$ ${[
                      "gastoalimentacion_se",
                      "gastovestido_se",
                      "gastogasolina_se",
                      "gastotransporte_se",
                      "gastotelefono_se",
                      "gastodiversiones_se",
                      "gastoautofinanciamiento_se",
                      "gastootros1_se",
                      "gastohipoteca_se",
                      "gastorenta_se",
                      "gastocolegiaturas_se",
                      "gastoservicios_se",
                      "gastodeudas_se",
                      "gastoinversiones_se",
                      "gastopension_se",
                      "gastootros2_se",
                    ]
                      .map((name) => parseFloat(getValues(name)) || 0)
                      .reduce((acc, value) => acc + value, 0)
                      .toFixed(2)}`}
                    readOnly
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">
          INGRESOS Y EGRESOS
        </p>
        <p className="text-justify text-gray-800 leading-relaxed">
          En la entrevista refirió que su ingreso mensual familiar es de
          aproximadamente{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.ingresomensual_se}`}
          </label>{" "}
          , esta compuesto por{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.compuestopor_se}`}
          </label>
          , también señala que el ingreso de su esposa es de{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.ingresoesposa_se}`}
          </label>{" "}
          sus ingresos extras se componen de{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.ingresosextra_se}`}
          </label>{" "}
          y ascienden a{" "}
          <Controller
            name="ascienden_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="ascienden_se"
                type="numeric"
                className="border border-gray-300 rounded-md pl-8 p-2 w-auto text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="$1,000"
              />
            )}
          />
          .
        </p>
        <p className="text-justify text-gray-800 leading-relaxed">
          También menciona que sus egresos familiares son de{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.egresosfam_se}`}
          </label>{" "}
          y están compuestos de{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.compuestosde_se}`}
          </label>{" "}
          y el de su esposa es de{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.esposaegreso_se}`}
          </label>
          , las deudas que tiene ascienden a{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.deudasascienden1_se}`}
          </label>
          , los gastos son de aproximadamente{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.gastosaprox_se}`}
          </label>
          .
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">DEUDAS</p>
        <p className="text-justify text-gray-800 leading-relaxed">
          Refiere que sus deudas ascienden a{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`$ ${queryConclusionSE.data?.deudasascienden2_se}`}
          </label>
          .
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">
          VEHICULOS E INMUEBLES
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Durante la entrevista señalo que tiene{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.cuantosvehiculos_se}`}
          </label>{" "}
          vehículo(s){" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.descripcionvehiculos}`}
          </label>{" "}
          , lo adquirió{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.comoadquirio2_se}`}
          </label>
          .
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">ASPECTOS LEGALES</p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Se le cuestiono al evaluado por problemas legales de cualquier índole
          que hubiera tenido.
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Negó haber demandado laboralmente a cualquiera de sus anteriores
          empleadores. Negó haber sido sujeto de investigaciones ministeriales
          averiguaciones previas o carpetas de investigación o judiciales en
          materia penal. Negó contar con procedimientos administrativos. Negó
          haber sido parte en juicios civiles o mercantiles.
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">DOMICILIO</p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Refiere que su domicilio actual es{" "}
          <label
            htmlFor="domicilio"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.calle || ""}, ${
              queryEvaluado.data?.numero_exterior || ""
            }, ${queryEvaluado.data?.colonia || ""}, ${
              queryEvaluado.data?.codigo_postal || ""
            }, ${queryEvaluado.data?.municipio || ""}, ${
              queryEvaluado.data?.estado || ""
            }, ${queryEvaluado.data?.pais || ""}`}
          </label>
          , que tiene viviendo{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.tiempoviviendo_se}`}
          </label>{" "}
          años en ese inmueble, que el inmueble es{" "}
          <Controller
            name="domicilioactual_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="domicilioactual_se"
                type="text"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="Rentado, Propio, etc."
              />
            )}
          />
          .
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Manifiesta llevar una buena relación con sus vecinos, aunque no los
          trata mucho.
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Señala a dos referencias vecinales{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.referenciavecinal1_se}`}
          </label>{" "}
          y{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.referenciavecinal2_se}`}
          </label>
          .
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">
          INFORMACIÓN BANCARIA
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Indica que es titular de la cuenta bancaria{" "}
          <Controller
            name="titularcuentabanco_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="titularcuentabanco_se"
                type="text"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="Cuenta..."
              />
            )}
          />{" "}
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">
          HABITOS Y ESPARCIMIENTO
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Comentó que en su tiempo libre prefiere{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.tiempolibre_se}`}
          </label>
          . Indicó no pertenecer a ningún club social o practicar algún deporte.
        </p>
        <p className="text-justify text-gray-800 leading-relaxed">
          También señala que{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.fuma_se === "true" ? "Sí" : "No"}`}
          </label>{" "}
          fuma, el consume{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.cuantofuma_se}`}
          </label>{" "}
          al día, que{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.toma_se === "true" ? "Sí" : "No"}`}
          </label>{" "}
          consume bebidas alcohólicas cada
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryConclusionSE.data?.cuantotoma_se}`}
          </label>{" "}
          dias, siendo la ultima vez el{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${
              queryConclusionSE.data?.ultimavez_se
                ? new Date(
                    queryConclusionSE.data.ultimavez_se + "T00:00:00"
                  ).toLocaleDateString("es-ES")
                : "Fecha no disponible"
            }`}
          </label>
          ,{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${
              queryConclusionSE.data?.consumedrogas_se === "true" ? "Sí" : "No"
            }`}
          </label>{" "}
          consume drogas
          <Controller
            name="drogasdescripcion_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                {...field}
                id="drogasdescripcion_se"
                className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                aria-label="drogasdescripcion_se"
                placeholder="Explica..."
              />
            )}
          />
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">
          EXPERIENCIA LABORAL
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          En este rubro, se describirá detalladamente su experiencia laboral
          desde el año a la{" "}
          <Controller
            name="aniolaboral_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="aniolaboral_se"
                type="numeric"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder=""
              />
            )}
          />{" "}
          a la fecha.
          <Controller
            name="externo1_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                {...field}
                id="externo1_se"
                onChange={(e) => field.onChange(e.target.value)}
                className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
                aria-label="externo1_se"
                placeholder="Descripción..."
              />
            )}
          />
        </p>
        <p className="text-justify text-gray-800 leading-relaxed">
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          externó que en tiempos inactivos laboró como chofer de manera
          independiente desde{" "}
          <Controller
            name="tiempolaborando1_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="tiempolaborando1_se"
                type="date"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="01/Enero/2025"
              />
            )}
          />{" "}
          hasta{" "}
          <Controller
            name="tiempolaborando2_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="tiempolaborando2_se"
                type="date"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="01/Enero/2025"
              />
            )}
          />
          .
        </p>
        <p className="text-justify text-gray-800 leading-relaxed">
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          señaló haber laborado como Chofer Ejecutivo, bajo la supervisión de{" "}
          <Controller
            name="supervision_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="supervision_se"
                type="text"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="¿Quien?"
              />
            )}
          />{" "}
          Coordinadora de Asesores{" "}
          <Controller
            name="telcoordinadora_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="telcoordinadora_se"
                type="text"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="(55) 11111111"
              />
            )}
          />
          , quien indicó que candidato cumplió con las expectativas del puesto
          porque es una persona responsable, respetuosa, confiable, con
          disposición, puntual, discreta, amable, respetuoso, buen manejo ante
          el estrés y sabe trabajar bajo presión, no obstante, considera que
          debe tomar un curso de manejo defensivo; corrobora una estancia de
          aproximadamente 1 año como Asistente Administrativo / Chofer ejecutivo
          y salió por reestructura Administrativa. Se ubicó el número{" "}
          <Controller
            name="telsinexito_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="telsinexito_se"
                type="text"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="(55) 11111111"
              />
            )}
          />
          sin tener éxito.{" "}
          <label
            htmlFor="nombre"
            className="text-gray-800 font-medium inline-block"
          >
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          externó que
          <Controller
            name="externo2_se"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="externo2_se"
                type="text"
                className="border border-gray-300 rounded-md p-2 w-auto inline-block mt-2 mb-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                placeholder="¿Que externó?"
              />
            )}
          />
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">
          CONDUCTA EN EL EXAMEN
        </p>

        <p className="text-justify text-gray-800 leading-relaxed">
          Al momento de realizar la evaluación, mencionó estar en buen estado de
          salud, psicológico y emocional para llevar a cabo la evaluación, por
          lo que durante la entrevista manifestó entender de manera clara y
          oportuna los cuestionamientos que se le realizaron; cabe señalar que
          durante el examen aseveró presentarse de manera voluntaria asentado su
          consentimiento mediante la firma del formato de autorización, aunado a
          lo anterior acató de manera clara y precisa las indicaciones que se le
          proporcionaron, durante la entrevista se mostró amable y
          participativo, por lo que la prueba se concluyó sin problema alguno.{" "}
        </p>
      </div>
      <div className="flex flex-col items-start border-dashed border-4 border-gray-300 rounded-lg p-6 bg-gray-50 space-y-6 relative">
        <p className="text-xl font-semibold text-gray-800">OBSERVACIONES</p>
        <Controller
          name="observaciones_se"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              {...field}
              id="observaciones_se"
              className="w-full p-4 min-h-[150px] text-sm text-gray-900 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400 resize-none"
              aria-label="observaciones_se"
              placeholder="Escribe tus observaciones aquí..."
            />
          )}
        />
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Campo Resultado */}
        <div className="col-span-1">
          <Label htmlFor="rfc">RESULTADO:</Label>
          <Controller
            name="resultado_conclusion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="resultado_conclusion"
                type="text"
                {...field}
                className="text-center w-full"
              />
            )}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="container mx-auto p-4">
      <form
        onSubmit={handleSubmit((data) => {
          const formData = {
            ...data,
            recomendacion: selectedRecommendation,
            color_se:
              selectedRecommendation === "recomendable"
                ? "verde"
                : selectedRecommendation === "con_reserva"
                ? "amarillo"
                : selectedRecommendation === "no_recomendable"
                ? "rojo"
                : "",
          };

          // Primero, enviamos la fecha (como ya lo hacías)
          mutateFechaSE.mutate(
            {
              data: { fecha_conclusionse: data.fecha_conclusionse },
              tipo: "put",
            },
            {
              onSuccess: () => {
                mutateSemaforoSE.mutate(
                  {
                    data: formData,
                    tipo: "post",
                  },
                  {
                    onSuccess: () => {
                      mutateConclusionSE.mutate(
                        {
                          data: formData,
                          tipo: "put",
                        },
                        {
                          onSuccess: () => {
                            mutateResultadoSE.mutate(
                              {
                                data: formData,
                                tipo: "post",
                              },
                              {
                                onSuccess: () => {
                                  navigate(
                                    `/socioeconomica/${evaluadosList_id}`
                                  );
                                },
                                onError: (error) => {
                                  console.error(
                                    "Error al guardar Resultado SE:",
                                    error
                                  );
                                  console.error(
                                    "Detalles del error:",
                                    error.response.data
                                  );
                                },
                              }
                            );
                          },
                          onError: (error) => {
                            console.error("Error al guardar Notas SE:", error);
                          },
                        }
                      );
                    },
                    onError: (error) => {
                      console.error("Error al guardar Semáforo SE:", error);
                    },
                  }
                );
              },
              onError: (error) => {
                console.error("Error al guardar Fecha Socioeconómica:", error);
              },
            }
          );
        })}
        className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden"
      >
        {renderHeader()}

        {currentPage === 1 && renderPage1()}
        {currentPage === 2 && renderPage2()}

        <div className="mt-6 p-4 flex justify-between">
          {/* Botón Cancelar */}
          {currentPage === 1 && (
            <Button
              color="red"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/socioeconomica/${evaluadosList_id}`);
              }}
              className="ml-2"
            >
              Cancelar
            </Button>
          )}

          {/* Botón Siguiente */}
          {currentPage === 1 && (
            <button
              type="button"
              className="bg-blue-500 text-white rounded px-4 py-2"
              onClick={() => {
                window.scrollTo(0, 0);
                handlePageChange(currentPage + 1);
              }}
            >
              Siguiente
            </button>
          )}

          {currentPage > 1 && (
            <Button
              color="blue"
              onClick={() => {
                window.scrollTo(0, 0);
                handlePageChange(currentPage - 1);
              }}
            >
              Anterior
            </Button>
          )}

          {/* Botón Guardar */}
          {currentPage === 2 && (
            <div className="flex space-x-4">
              <button
                type="submit"
                className="bg-green-500 text-white rounded px-4 py-2"
              >
                Guardar
              </button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};
